import { computed, ref, ComputedRef } from 'vue'
import { useApi } from '@/composables/useApi'

export type DocumentType = {
    [key: string]: string | number
    id: number
    name: string
    symbol: string
}

const isLoading = ref<boolean>(false)
const documentTypes = ref<DocumentType[]>([])
const isEmpty = computed(() => documentTypes.value.length === 0)

export const useDocumentTypes = (): {
    fetchDocumentTypes: () => Promise<void>
    documentTypes: ComputedRef<DocumentType[]>
    isLoading: ComputedRef<boolean>
    isEmpty: ComputedRef<boolean>
} => {
    const { useGet } = useApi()

    async function fetchDocumentTypes(): Promise<void> {
        if (!isEmpty.value) return

        isLoading.value = true
        try {
            const { status, data } = await useGet('/document-types')
            if (status === 200 && data.data) {
                documentTypes.value = data.data.items
            }
        } finally {
            isLoading.value = false
        }
    }

    return {
        fetchDocumentTypes,
        documentTypes: computed(() => documentTypes.value),
        isLoading: computed(() => isLoading.value),
        isEmpty,
    }
}
